<template>
  <b-list-group class="col-md-12 mt-3 ml-3 mb-2" >
    <b-list-group-item class="justify-content-between align-items-center">
      <div class="row">
        <div class="col-md-9 col-sm-9">
          <b>@{{template.composer}}</b><br>
          <b><small class="text-muted"><em><i class="fa fa-user"></i> publisher</em></small></b>
        </div>
        <div class="col-md-3 col-sm-3">
            <div class="pull-right">
              <b-dropdown class="btn-group" variant="p-0" right no-caret>
                <template slot="button-content">
                  <i class="icon-options-vertical icons font-1xl"></i>
                </template>
                <b-dropdown-item title="Send as SMS" v-b-tooltip.hover @click="handleSendAsSMS()"><i class="icon-paper-plane icons font-1xl"></i>Send as SMS</b-dropdown-item>
              <b-dropdown-item v-if="isMobileDevice" title="Share" @click="handleShare()"><i class="icon-share icons font-1xl"></i>Share</b-dropdown-item>
                <b-dropdown-item v-b-tooltip.hover title="Copy"
                    v-clipboard:copy="template.message"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"><i class="fa fa-clone font-1xl"></i>Copy</b-dropdown-item>
                <template v-if="isPrivate">
                  <b-dropdown-item title="Edit" v-b-tooltip.hover @click="handleMessageEdit()"><i class="fa fa-edit"></i>Edit</b-dropdown-item>
                  <b-dropdown-item @click="handleMessageDelete()"><i class="icon-trash icons font-1xl"></i>Delete</b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
        </div>
      </div>
    </b-list-group-item>
    <b-list-group-item class="flex-column align-items-start">
      <div class="row p-3">
        {{template.message}}
      </div>
    </b-list-group-item>
    <b-list-group-item class="flex-column align-items-start">
      <b-navbar>
        <b-nav>
          <b-nav-item disabled><i class="icon-eye icons font-1xl"></i> {{template.total_view}}</b-nav-item>
          <b-nav-item><i class="icon-like icons font-1xl"></i> {{template.up_rating}}</b-nav-item>
          <b-nav-item><i class="icon-dislike icons font-1xl"></i> {{template.down_rating}}</b-nav-item>
        </b-nav>
        <!-- Right aligned nav items -->
        <b-nav class="ml-auto">
          <span class="badge badge-primary pb-1 badge-pill" v-if="template.up_rating > template.down_rating">Good</span>
          <span class="badge badge-secondary pb-1 badge-pill" v-else-if="template.up_rating == template.down_rating">Flat</span>
          <span class="badge badge-warning pb-1 badge-pill" v-else>Poor</span>
        </b-nav>
      </b-navbar>
    </b-list-group-item>
  </b-list-group>
</template>

<script> 
import Vue from 'vue'
import {EventBus} from '@/events/bus.event'
import { isMobileDevice } from '@/shared/utils'

import { Plugins } from '@capacitor/core'
const { Share } = Plugins

export default {
  name: 'TemplateItem',
  components: {
  },
  props: {
    template: {
      type: Object,
      default: null
    },
    isPrivate: Boolean,
  },
  data () {
    return {
     isChecked: false,
      Share: Share,
      isMobileDevice: false,
    }
  },
  computed: {

  },
  watch: {
    isChecked: function (flag) {
      this.showNewsletterSelection(flag)
    },
  },
  created: async function() {
    EventBus.$on('newsletter-selection-'+this.template.id, this.toggleSelection)
    this.isMobileDevice = await isMobileDevice()
  },
  notifications: {
    copyNotifError: {
      title: 'Failed',
      message: 'There was error copying the content',
      type: 'error'
    },
    copyNotifSuccess: {
      title: 'Success',
      message: 'Content copied',
      type: 'success'
    }
  },
  methods: {
    showNewsletterView: function() {
      if(!this.isChecked)
        this.$emit('show-newsletter-view', this.template)
    },
    
    onCopy: function (e) {
      this.copyNotifSuccess()
    },
    onCopyError: function (e) {
      this.copyNotifError()
    },
    showNewsletterSelection: function(flag) {
      this.$emit('show-newsletter-selection', this.template, flag)
    },
    toggleSelection: function(flag) {
      this.isChecked = flag
    },
    handleMessageEdit: function () {
      this.$emit('template-message-edit', this.template)
    },
    handleMessageDelete: function () {
      this.$emit('template-message-delete', this.template.id)
    },
    handleSendAsSMS: function() {
      this.$emit('template-send-as-sms', this.template.message)
    },
    handleShare: async function() {
      let shareRet = await Share.share({
        title: `SMS template by ${this.template.composer}`,
        text: this.template.message,
        url: 'https://app.zigatext.com',
        dialogTitle: 'Share with buddies',
      })
    }
  }
}
</script>
